// If a 401 occurs on one of these routes then don't redirect to /auth.
// Users are allowed to be on these routes unauthenticated.
const NO_REDIRECT_ALLOW_LIST = [
  '/magic',
  '/magic-extension',
  '/dashboard',
  // The experience edit route handles its own logged-out state by rendering an
  // "Access denied" view (e.g. when following an invite link before signing in).
  '/experience',
  // Published pages are viewable anonymously; a stray 401 (e.g. from an authed
  // query issued on a published view) must not bounce the viewer to /auth.
  '/page',
];

type Return = {
  shouldRedirect: boolean;
  path: string;
};

export const shouldRedirectOnLogout = (): Return => {
  const shouldRedirect = !NO_REDIRECT_ALLOW_LIST.some((allowedPath) =>
    window.location.pathname.startsWith(allowedPath)
  );
  return {
    shouldRedirect,
    path: '/auth',
  };
};
